import React, { useEffect, useState } from "react";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { pushlist } from "../../../services/push";

/**
 * Push Notification > Push List. History of every manual "Send Push" broadcast,
 * newest first: when it went out, the audience, branch, title and message.
 */
const AUDIENCE_LABELS = {
    members: "Members",
    employees: "Employees",
    all: "All (Members & Employees)",
};

export default function ListPush() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    function listall() {
        setLoading(true);
        pushlist().then((res) => {
            if (res?.status === true && Array.isArray(res.data)) {
                setRows(res.data);
            }
            setLoading(false);
        });
    }

    useEffect(() => {
        listall();
    }, []);

    const columnDefs = [
        {
            headerName: "Date",
            field: "created_at",
            width: 130,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) =>
                params.value ? moment(params.value).format("DD-MM-YYYY") : "-",
        },
        {
            headerName: "Time",
            field: "created_at",
            width: 120,
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) =>
                params.value ? moment(params.value).format("hh:mm A") : "-",
        },
        {
            headerName: "Sent To",
            field: "sent_to",
            width: 160,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) => AUDIENCE_LABELS[params.value] || params.value,
        },
        {
            headerName: "Branch",
            field: "branch_name",
            width: 160,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Title",
            field: "title",
            width: 200,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            tooltipField: "title",
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Recipients",
            field: "recipients_count",
            width: 120,
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Message",
            field: "message",
            flex: 1,
            minWidth: 260,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            tooltipField: "message",
            cellStyle: { textAlign: "left" },
        },
    ];

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Push List</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Push Notification</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Push List
                    </li>
                </ol>
            </div>

            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="container">
                    <div className="ag-theme-alpine ag-style mt-2">
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={rows}
                            pagination="true"
                            paginationPageSize="10"
                            sortingOrder={["asc", "desc"]}
                            suppressDragLeaveHidesColumns={true}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
